'use strict';

var BidPriceChartDirective = function BidPriceChartDirective(Chart) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/bid-price-chart.html'),
    controller: 'BidPriceChartController',
    scope: {
      entityData: '=',
      selectedLegCabin: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      scope.renderChartDataPresent = function renderChart(data) {
        chart.render(data);
      };
      scope.$watch('selectedLegCabin', scope.updateChart);
    }
  };
};
BidPriceChartDirective.$inject = ['BidPriceChart'];
module.exports = BidPriceChartDirective;